import React from 'react'
import Icon from '../__assets__/download-file-icon.png'
import { Link, Logo, FileName as _FileName } from './__styles__'



export default function FileName({ title = '', url }) {
    return (
        <_FileName>
            <Link href={url}>{title}
                <Logo src={Icon} style={{ width: 16, height: 16, marginLeft: 12, cursor: 'pointer' }} />
            </Link>
        </_FileName>
    )
}
